export default "__VITE_ASSET__871cf96e__"